import React from 'react'
import { connect } from 'react-redux'
import { defaultFontSize, updateFontSize } from '../../../store/actions/fontSize'

import { ReactComponent as Plus } from 'images/icons/plus2.svg'
import { ReactComponent as Minus } from 'images/icons/minus.svg'

import { Container } from './styled'
import { Button } from '../button'

const FontSize = props => {
    const { storeFS, setFontSize, setDefault } = props

    const localFS = localStorage.getItem('prefferedFontSize')

    if (storeFS !== '' && storeFS !== localFS)
        localStorage.setItem('prefferedFontSize', storeFS)

    if (storeFS === '')
        setFontSize(localFS || setDefault())

    const handleFontSize = option => {
        if (option === 'less' && storeFS > 18.75)
            setFontSize(storeFS - 16.25) && console.log(storeFS)
        if (option === 'more' && storeFS < 490)
            setFontSize(storeFS + 16.25) && console.log(storeFS)

        if (option === 'default')
            setDefault() && console.log(storeFS)

        document.body.parentElement.style.fontSize = `${storeFS}%`
    }

    return <Container>
        <Button secondary onClick={() => handleFontSize('less')}><Minus /></Button>
        <Button secondary onClick={() => handleFontSize('default')}>default</Button>
        <Button secondary onClick={() => handleFontSize('more')}><Plus /></Button>
    </Container>
}

const mapStateToProps = store => ({
    storeFS: store.fontSize.value
})

const mapDispatchToProps = dispatch => ({
    setFontSize: size => dispatch(updateFontSize(size)),
    setDefault: size => dispatch(defaultFontSize(size)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FontSize)